<template>
	<div id="emptycontent">
		<div class="icon-mail" />
		<h2>{{ t('mail', 'No messages in this mailbox') }}</h2>
	</div>
</template>

<script>
export default {
	name: 'EmptyMailbox',
}
</script>
